import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  value: 'not-ready',
  missed_entries: [],
}

export const quizStateSlice = createSlice({
  name: 'quiz',
  initialState,
  reducers: {
    inProcess: (state) => {
      state.value = 'in-process'
    },
    notReady: (state) => {
      state.value = 'not-ready'
    },
    finished: (state) => {
      state.value = 'finished'
    },
    pushNewEntry: (state, action) => {
      state.missed_entries = [...state.missed_entries, ...action.payload]
    },
    clearEntries: (state) => {
      state.missed_entries = []
    },
  },
})

export const { inProcess, notReady, finished, pushNewEntry, clearEntries } =
  quizStateSlice.actions

export default quizStateSlice.reducer
